'use strict'

module.exports = function() {
  return (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/detect-browser-language/index.js
// module id = 700
// module chunks = 0